var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3534 1.93353L6.59351 6.69173C6.26577 7.01975 5.73345 7.01975 5.40571 6.69173L0.645831 1.93353C0.317534 1.60552 0.317534 1.07403 0.645831 0.746012C0.973847 0.417996 1.50533 0.417996 1.83363 0.746012L5.99961 4.91059L10.1656 0.746012C10.4936 0.417996 11.0257 0.417996 11.3534 0.746012C11.6817 1.07403 11.6817 1.60552 11.3534 1.93353Z",
    fill: "#231F20",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDark);
export default __webpack_public_path__ + "static/media/arrow-dark.b43a651811b601d99129b371a88f8553.svg";
export { ForwardRef as ReactComponent };